import { render, staticRenderFns } from "./facilities-table.vue?vue&type=template&id=95e476ba&"
import script from "./facilities-table.vue?vue&type=script&lang=js&"
export * from "./facilities-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports